export const MAX_RECONNECTION_COUNT = 10;
export const RECONNECTION_DELAY_MS = 2000;
// optional additional delay before returning the underlying WebSocket, simulating a slow network connection
export const NETWORK_TEST_WEB_SOCKET_DELAY_SECONDS = 0;
